import script from "./EditResourceView.vue?vue&type=script&setup=true&lang=js"
export * from "./EditResourceView.vue?vue&type=script&setup=true&lang=js"

import "./EditResourceView.vue?vue&type=style&index=0&id=3c4dad1b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c4dad1b"]])

export default __exports__